import * as React from "react";
import MuiTab from "@material-ui/core/Tab";
import type { UiBaseProps } from "../uiProps.utils";

export type TabValue = string | number;

export enum TabHeight {
  // About 10% under the default 48px, without going below the 44px tap target.
  COMPACT = "2.75rem",
}

export type TabProps = Omit<UiBaseProps, "children"> & {
  value: TabValue;
  label: React.ReactNode;
  disabled?: boolean;
  height?: TabHeight;
};

// Tabs hands each tab its selected state and click handler as extra props; they pass straight through.
export const Tab: React.FC<TabProps> = ({ height, style, ...rest }) => (
  <MuiTab style={height ? { minHeight: height, ...style } : style} {...rest} />
);
